import * as React from "react"
import Button from "../buttons/button";

import blast_logo from "./../../images/blast_logo.png";

export default class HomeHeroSection extends React.Component {
    render() {
        return (
            <section className={'home-hero-section'}>
                <div className={'container'}>
                    <div className={'row justify-content-center'}>
                        <div className={'col-auto'}>
                            <h1>{this.props.heroData.title}</h1>
                        </div>
                        <div className={'col-auto'}>
                            {/*<div className={'text'} dangerouslySetInnerHTML={{__html: this.props.heroData.text}}/>*/}
                            <div className={'text'}>
                              <span>Boom Bots are onchain crypto trading and investing bots.</span>
                              <br/>
                              <span style={{position:"relative",top:"8px"}}>
                                Live on
                                <a href="https://blast.io" target="_blank">
                                  <img src={blast_logo} alt="blast" style={{width:"100px",margin:"0 8px",position:"relative",top:"-5px"}}/>
                                </a>
                                Testnet!
                              </span>
                            </div>
                            <div className={'text'}>
                              <span>Create yours now</span>
                            </div>
                        </div>
                        <div className={'col-12 justify-content-center d-flex'}>
                            {this.props.heroData.buttons.map((button,index) => (
                                <Button key={index} class={button.class} type={button.type} text={button.text} url={button.url}/>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
